<span [title]="date() | date:'d-MMM-yyyy hh:mm a'">
  {{ date() | timeAgo }}
</span>
@if (username()) {
  <span class="username">By {{ username() | username }}</span>
}
